import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PhoneVerifiedImg from '../../assets/phone-verified.svg';
import Blockquote from '../Blockquote';
import Button from '../Button';
import ModalHeader from '../ModalHeader';
import TextInput from '../TextInput/TextInput';

export type customPhoneMessagingModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  handleClose: () => void;
  phoneData: any;
  isVerified: boolean;
  setVerified: (verified: boolean) => void;
}>;

const PhoneMessagingModal = ({
  showModal,
  handleClose,
  phoneData,
  isVerified,
  setVerified,
  ...props
}: customPhoneMessagingModalProps) => {
  const [codeSend, setCodeSend] = React.useState(false);
  const navigate = useNavigate();

  const handleSendCode = () => {
    setCodeSend(!codeSend);
  };

  const handleVerifyCode = () => {
    setVerified(true);
  };

  const handleToCommunications = () => {
    handleClose();
    navigate('/profile/communication');
  };

  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="lg">
      {isVerified ? (
        <>
          <ModalHeader onHide={handleClose} closeButton />
          <ModalBody>
            <section className="d-flex justify-content-center">
              <h4>Success</h4>
            </section>
            <section className="d-flex justify-content-center mt-12">
              <img src={PhoneVerifiedImg} alt="Phone Verified" />
            </section>
            <section className="mt-12 lh-xs">
              <h6>Mobile Phone has been verified</h6>
              <span className="text-caption fw-light lh-xs">
                Head to <span className="text-primary">communications</span> to
                make adjustment to subjects that informs you via sms.
              </span>
            </section>
          </ModalBody>
          <ModalFooter>
            <Button variant="primary-outline" onClick={handleClose} className={'mt-7 mt-lg-0'}>
              Close
            </Button>
            <Button variant="primary" onClick={handleToCommunications}>
              Communications
            </Button>
          </ModalFooter>
        </>
      ) : (
        <>
          <ModalHeader onHide={handleClose}>
            <h4>Enable text messaging</h4>
          </ModalHeader>
          <ModalBody>
            <section>
              <Blockquote variant="primary">
                <span>
                  Your phone number{' '}
                  <span className="text-primary">{phoneData.phone}</span> has
                  been saved successfully!
                </span>
              </Blockquote>
            </section>
            <section className="d-flex flex-column mt-12">
              <span className="fw-normal text-fs-6 lh-xs">Next Steps</span>
              <span className="fw-light text-fs-6 pt-7 lh-xs">
                Verify your cell phone number to receive text notifications
                related to this Site and the Services provided. The
                communications page allows you to delete or refine message
                options. Message frequency may vary depending upon your
                selections and meeting message conditions.
              </span>
              <span className="fw-light text-fs-6 pt-7 lh-xs">
                Message and data rates may apply to text messages
              </span>
              <span className="text-indigo fw-light text-fs-6 pt-7 lh-xs">
                Terms of Use
              </span>
              <span className="text-indigo fw-light text-fs-6 lh-xs">
                Privacy Statement
              </span>
            </section>
            <section className="d-flex flex-column mt-12 border-light-gray rounded-1 p-10">
              <span className="fw-normal text-fs-6 lh-xs">Verification</span>
              <span className="fw-light text-fs-6 lh-xs pt-7">
                To authorize text messages you must:
              </span>
              <span className="fw-light text-fs-6 lh-xs text-indigo ms-lg-12 pt-7">
                <span className="text-gray-500">
                  <FontAwesomeIcon icon={light('check')} className="pe-3" />
                </span>
                Click the “Send Code” button
              </span>
              <span className="fw-light text-fs-6 lh-xs text-indigo ms-lg-12 pt-4">
                <span className="text-gray-500">
                  <FontAwesomeIcon icon={light('check')} className="pe-3" />
                </span>
                Enter the code sent to your phone
              </span>
              <span className="pt-7">
                <Button
                  variant={codeSend ? 'primary-outline' : 'primary'}
                  onClick={handleSendCode}
                >
                  {codeSend ? 'Resend Code' : 'Send Code'}
                </Button>
              </span>
              {codeSend && (
                <span className="pt-7">
                  <Blockquote
                    variant="primary"
                    lineVariant="default"
                    className="py-7"
                  >
                    <span className="lh-xs">
                      A verification code has been sent to your mobile device
                      via SMS. you may request another code after one minute.
                    </span>
                  </Blockquote>
                </span>
              )}
              <span className="pt-7">
                <TextInput
                  label="Enter the Code you received via SMS:"
                  type={'code'}
                  leftIcon={light('hashtag')}
                  placeholder={'Enter Code'}
                  disabled={!codeSend}
                />
              </span>
            </section>
          </ModalBody>
          <ModalFooter>
            <Button variant="primary-outline" onClick={handleClose} className={'mt-7 mt-lg-0'}>
              Cancel
            </Button>
            <Button
              variant="primary"
              disabled={!codeSend}
              onClick={handleVerifyCode}
            >
              Verify
            </Button>
          </ModalFooter>
        </>
      )}
    </Modal>
  );
};

export default PhoneMessagingModal;
